import {
  Component,
  forwardRef,
  inject,
  OnDestroy,
  OnInit,
  HostBinding,
} from '@angular/core';

import {
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormFieldComponent } from '../form-field/form-field.component';
import { InputComponent } from '../input/input.component';
import { LayoutService } from '../../../../core/services/layout.service';
import { NumberInputComponent } from '../number-input/number-input.component';

// Define the public interface for the component's value
export interface Contact {
  name: string | null;
  email: string | null;
  phone: string | null;
  ext: string | null;
}

@Component({
  selector: 'app-contact-input',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormFieldComponent,
    InputComponent,
    NumberInputComponent
],
  templateUrl: './contact-input.component.html',
  styleUrls: ['./contact-input.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ContactInputComponent),
      multi: true,
    },
  ],
})
export class ContactInputComponent
  implements ControlValueAccessor, OnInit, OnDestroy
{
  private readonly fb = inject(FormBuilder);
  private readonly layoutService = inject(LayoutService);
  private subs = new Subscription();

  @HostBinding('class.is-mobile-layout')
  get isMobileLayout() {
    return this.layoutService.isTabletOrBelow();
  }

  protected form: FormGroup;

  onChange: (value: Contact | null) => void = () => {};
  onTouched: () => void = () => {};

  constructor() {
    this.form = this.fb.group({
      name: [null],
      email: [null, [Validators.email]],
      phone: [null],
      ext: [null],
    });
  }

  ngOnInit(): void {
    this.subs.add(
      this.form.valueChanges.subscribe((value) => {
        this.onChange(this.form.valid ? value : null);
      })
    );
  }

  writeValue(value: Contact | null): void {
    if (value) {
      this.form.patchValue(value, { emitEvent: false });
    } else {
      this.form.reset({}, { emitEvent: false });
    }
  }

  registerOnChange(fn: (value: Contact | null) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
